import { render, staticRenderFns } from "./ChangeOwnerConfig.vue?vue&type=template&id=bf025cd8&scoped=true"
import script from "./ChangeOwnerConfig.vue?vue&type=script&lang=js"
export * from "./ChangeOwnerConfig.vue?vue&type=script&lang=js"
import style0 from "./ChangeOwnerConfig.vue?vue&type=style&index=0&id=bf025cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf025cd8",
  null
  
)

export default component.exports